<template>
  <div class="flex flex-col flex-1 h-full overflow-auto bg-n-background px-6">
    <router-view />
  </div>
</template>
